import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subscriptionTermsDaysFrequency'
})
export class SubscriptionTermsDaysFrequencyPipe implements PipeTransform {
  transform(productName: string): string {
    if (!productName || !productName.includes('Subscription'))
      return '-';

    if (productName.includes('1 Unit'))
      return '30 days';
    else if (productName.includes('3 Unit'))
      return '90 days';
    else if (productName.includes('6 Unit'))
      return '180 days';
    else
      return '30 days'; // Default subscription days period
  }
} 